import React from 'react';
import './AccountMenu.scss';
import { ReactComponent as CheckCircleSmall } from '../assets/check_circle_small.svg';
import { ReactComponent as Warning } from '../assets/warning.svg';
import './Feedback.scss';
import { ErrorDetail } from '../services/models';
import { Link } from 'react-router-dom';

type MessageType = 'success' | 'error';

type Props = {
  messages?: string[];
  messageDetails?: ErrorDetail[];
  message?: string | null;
  type: MessageType;
};

const Feedback: React.FC<Props> = ({
  messages,
  messageDetails,
  message,
  type
}) => {
  if (
    (!messages || messages.length === 0) &&
    (!messageDetails || messageDetails.length === 0) &&
    !message
  ) {
    return null;
  }

  if (!messageDetails) {
    messageDetails = [];
  }

  if (message) {
    messageDetails = [...messageDetails, { message }];
  }

  if (messages) {
    messageDetails = [
      ...messageDetails,
      ...messages.map((p) => ({ message: p }))
    ];
  }

  if (type === 'error') {
    return (
      <div className="messages error">
        <ul>
          {messageDetails.map((p, i) => (
            <li key={i}>
              <Warning />
              <span>{p.message}</span>
              {p.requiresUpgrade && (
                <>
                  {' '}
                  <Link to="/account/subscription">Upgrade here</Link>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className="messages success">
      <ul>
        {messageDetails.map((p, i) => (
          <li key={i}>
            <CheckCircleSmall />
            <span>{p.message}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Feedback;
